module.exports = __webpack_public_path__ + "img/brightcove_plugins.3f6458a9.svg";